<template>
  <div v-if="defaultText !== ''" class="selector" :class="[openSelector ? 'open' : '']">
        <div class="label" @click="openSelector = !openSelector;">
            <p>{{currentOption === -1 ? defaultText : options[currentOption].display_name}} <span v-if="!hideDuration && options[currentOption] !== undefined">{{options[currentOption].duration}}</span></p>
            <img src="@/assets/icons/icon_tert-nav-arrow.svg" alt="">
        </div>
        <div class="options">
            <button 
                v-for="(option, id) in options"
                @click="currentOption = id; openSelector = false; $emit('selected', id);"
                :key="id"
            >{{option.display_name}}</button>                                
        </div>
    </div>       
</template>

<script>
export default {
    name:'Dropdown',
    props : {
        hideDuration:Boolean,
        options : {
            type:Array
        },
        defaultText: {
            type:String
        }, 
        currentOption: {
            type:Number,
            default: -1
        }
    },
    data: () => ({
        openSelector:false,
    }),
}
</script>

<style lang="scss" scoped>
    .selector {        
        width: 330px;
        border-radius: 10px;
        background: linear-gradient(135deg, #313131 0%, #141414 100%);
        box-shadow: 0 10px 20px 0 rgba(0,0,0,0.2);
        margin-bottom: 40px;    
        .label {
            display: flex;
            justify-content: space-between;
            user-select: none;
            cursor: pointer;
            padding:30px 20px;
            p {
                margin:0;
            }
            span {
                background-image: linear-gradient(269deg, #f5831f 0%, #fed208 100%);
                -webkit-background-clip: text;
                -webkit-text-fill-color: transparent;
                margin-left:1em;
            }
            img {
                transform:rotateZ(90deg);
            }
        }
        .options {
            position:absolute;
            top:100%;
            left:0;
            max-height: 0;
            overflow: hidden;
            transition: max-height 0.25s cubic-bezier(1, 0.5, 0.8, 1);
            &::-webkit-scrollbar {
                width: 5px;
            }
            &::-webkit-scrollbar-track {
                background-color: #2E2E30;
            }
            &::-webkit-scrollbar-thumb {
                background-color: #B2B3B8;
            }
            button {
                background: linear-gradient(135deg, #313131 0%, #141414 100%);            
                width:100%;
                padding:15px 10px;
                color: #FFF;
                font-family: "Gotham";
                font-weight:bold;
                text-transform: uppercase;
                border:none;
                outline:none;
                border-top:1px solid #fff;
                user-select: none;
                cursor: pointer;
            }
        }
        &.open {
            .options {
                overflow:auto;
                max-height:calc(100vh - 400px);
            }
            &.hotels .options {
                max-height:300px;
            }
        }
    }
</style>